import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useInvalidateShopDomains } from "./use-shop-domains";

export default function useTestDomainStatus(shop: ShopDto) {
  const invalidateShopDomains = useInvalidateShopDomains(shop.id);

  return useApiMutation<"post", "/shops/{shopId}/preferences/notifications/domains/check-status", void>(
    "post",
    "/shops/{shopId}/preferences/notifications/domains/check-status",
    {
      invalidate: invalidateShopDomains,
      notify: { success: false },
      mapVariables: () => ({
        params: { path: { shopId: shop.id } },
      }),
    },
  );
}
